document.querySelectorAll('.read-more-link').forEach((readMoreLink) => {
  readMoreLink.addEventListener('click', (e) => {
    e.preventDefault();

    const readMoreTexts = readMoreLink.querySelectorAll(':scope > span');
    readMoreTexts.forEach((readMoreText) => {
      readMoreText.classList.toggle('hidden');
    });
    readMoreLink.previousElementSibling.classList.toggle('show-all');
  });
});
